import { v4 as uuidv4 } from 'uuid';

// Detect if the device is a mobile device
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Get the device type (computer or mobile)
export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'computer';
};

// Get the device UUID or generate a new one if it doesn't exist
export const getDeviceUUID = () => {
  const storageKey = `prospxion_${getDeviceType()}_uuid`;
  let deviceUUID = localStorage.getItem(storageKey);
  
  if (!deviceUUID) {
    deviceUUID = uuidv4();
    localStorage.setItem(storageKey, deviceUUID);
  }
  
  return deviceUUID;
};

// Clear the stored UUID (for logout)
export const clearDeviceUUID = () => {
  const storageKey = `prospxion_${getDeviceType()}_uuid`;
  localStorage.removeItem(storageKey);
};
